// Public, no-login confirmation page reached from The Pulse email footer:
// /pulse/unsubscribe?token=...  Mirrors ResetPasswordPage's public-page pattern.
import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Activity, CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const ACCENT = "#0E1B2A";

export default function PulseUnsubscribePage() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [status, setStatus] = useState("loading"); // loading | done | error
    const [info, setInfo] = useState(null);
    const [err, setErr] = useState("");

    useEffect(() => {
        if (!token) {
            setStatus("error");
            setErr("This unsubscribe link is missing its token.");
            return;
        }
        api.post("/pulse/unsubscribe", { token })
            .then(({ data }) => { setInfo(data); setStatus("done"); })
            .catch((e) => {
                setErr(e.response?.data?.detail || "This unsubscribe link is invalid or has expired.");
                setStatus("error");
            });
    }, [token]);

    return (
        <div className="min-h-screen w-full grid place-items-center bg-[#EDEAE3] p-6" data-testid="pulse-unsubscribe-page">
            <div className="w-full max-w-[440px] bg-white border rounded-[16px] shadow-brand p-8 text-center" style={{ borderColor: "#DCD7CC" }}>
                <div className="w-11 h-11 rounded-full grid place-items-center mx-auto mb-4" style={{ background: "#0E1B2A" }}>
                    <Activity className="w-5 h-5" style={{ color: "#F6A609" }} />
                </div>
                <div className="text-[11px] font-bold tracking-[2px] uppercase mb-1" style={{ color: "#9A8F76" }}>The Pulse</div>

                {status === "loading" && (
                    <div className="py-4" data-testid="pulse-unsub-loading">
                        <Loader2 className="w-6 h-6 mx-auto animate-spin" style={{ color: "#0E1B2A" }} />
                        <p className="text-[13px] mt-3" style={{ color: "#6B6455" }}>Updating your preferences…</p>
                    </div>
                )}

                {status === "done" && (
                    <div data-testid="pulse-unsub-done">
                        <CheckCircle2 className="w-10 h-10 mx-auto mb-3" style={{ color: "#12A150" }} />
                        <h1 className="font-bold text-[19px] mb-1" style={{ color: "#0E1B2A" }}>You've been unsubscribed</h1>
                        <p className="text-[13px]" style={{ color: "#6B6455" }}>
                            {info?.name ? `${info.name}, ` : ""}you won't receive the weekly Pulse digest
                            {info?.client_name ? ` for ${info.client_name}` : ""} any more.
                        </p>
                    </div>
                )}

                {status === "error" && (
                    <div data-testid="pulse-unsub-error">
                        <XCircle className="w-10 h-10 mx-auto mb-3" style={{ color: "#C23B3B" }} />
                        <h1 className="font-bold text-[19px] mb-1" style={{ color: "#0E1B2A" }}>Something went wrong</h1>
                        <p className="text-[13px]" style={{ color: "#6B6455" }}>{err}</p>
                    </div>
                )}

                <div className="mt-6">
                    <Link to="/login" className="text-[12px] font-semibold hover:underline" style={{ color: ACCENT }}>
                        Back to Priority Risk
                    </Link>
                </div>
            </div>
        </div>
    );
}
